import { defineMessages } from 'react-intl';

export default defineMessages({
    userSaveFailed: {
        id: 'portal.views.administration-table.user.deactivate.Saving User Failed',
        defaultMessage: 'Saving User Failed',
    },
    userSaveFailedMessage: {
        id: 'portal.views.administration-table.user.deactivate.The user is a Primary Contact',
        defaultMessage: 'The user is a Primary Contact. Please assign a different Primary Contact before deactivating this user.',
    },
    ok:{
        id: 'portal.views.administration-table.user.deactivate.Ok',
        defaultMessage: 'Ok'
    },
    savedFailed: {
        id: 'portal.views.administration-table.user.Saving User Failed, Please Contact Administrator',
        defaultMessage: 'Saving User Failed, Please Contact Administrator'
    }
});
